<template>
  <b-modal
    title="DISPOSITIVO"
    size="md"
    id="view_device"
    no-close-on-backdrop
    no-close-on-esc
    :busy="loading"
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <b-form @submit.prevent="evOnSubmit">
      <b-row>
        <b-col>
          <LabelRequiredField label="Nome" />
          <b-input type="text" ref="autofocus" v-model="name"></b-input>
          <small class="form-text text-muted">Exemplo: Computador Sala 1</small>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <LabelRequiredField label="Código" />
          <b-input type="text" v-model="code"></b-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-checkbox :value="1" :unchecked-value="0" v-model="status">
            LIBERADO
          </b-checkbox>
        </b-col>
      </b-row>
      <WarningRequiredFields />
      <ErrorsMessages :errors="errors" />
      <b-row align-h="between">
        <b-col cols="auto">
          <v-btn class="btn-return" @click="$bvModal.hide('view_device')">
            <i class="fa fa-times mr-2 text-twenty"></i>
            CANCELAR
          </v-btn>
        </b-col>
        <b-col cols="auto">
          <confirmation-dialog
            message-title="EXCLUIR?"
            message-body="Deseja realmente excluir?"
            open-class="btn-delete"
            open-left-icon="fa-trash"
            open-text="EXCLUIR"
            @yes="remove"
          />
          <v-btn type="submit" class="btn-save ml-2">
            <i class="fa fa-check mr-2 text-twenty"></i>
            SALVAR
          </v-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import LabelRequiredField from "../Components/LabelRequiredField";
import ConfirmationDialog from "../Components/ConfirmationDialog";
import api from "../../services/api";
import toast from "../../lib/ToastNotification";

export default {
  name: "AddDevice",

  components: {
    ErrorsMessages,
    WarningRequiredFields,
    LabelRequiredField,
    ConfirmationDialog,
  },

  props: {
    device: [Object, null],
  },

  data() {
    return {
      errors: [],
      loading: false,

      name: "",
      code: "",
      status: 1,
    };
  },

  watch: {
    device() {
      this.name = this.device ? this.device.name : "";
      this.code = this.device ? this.device.code : "";
      this.status = this.device ? this.device.status : 1;

      if (this.device) this.$bvModal.show("view_device");
    },
  },

  methods: {
    async evOnShow() {
      this.errors = [];
      this.loading = false;
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {
      this.$emit("close");
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = {
          id: this.device.id,
          name: this.name,
          code: this.code,
          status: this.status,
        };
        const response = await api.patch("/rest-home/device", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$emit("updated");
          this.$bvModal.hide("view_device");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async remove() {
      try {
        this.loading = true;

        const params = { id: this.device.id };
        const response = await api.delete("/rest-home/device", {
          params,
        });
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$emit("updated");
          this.$bvModal.hide("view_device");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>
